// Helpers de lecture du champ `media` (JSONB) des produits de la table Boutique `product_items`.

export interface ProductMediaItem {
  url: string;
  type: string;
}

/**
 * Extrait la première image d'un produit à partir de son champ `media`.
 * `media` peut arriver sous forme de tableau déjà parsé ou de chaîne JSON.
 */
export function getProductImage(media: unknown): string | null {
  if (!media) return null;

  let items: ProductMediaItem[] = [];
  if (Array.isArray(media)) {
    items = media as ProductMediaItem[];
  } else if (typeof media === 'string') {
    try {
      const parsed = JSON.parse(media);
      if (Array.isArray(parsed)) items = parsed;
    } catch {
      return null;
    }
  }

  const image = items.find((m) => m.type === 'image');
  return image?.url || items[0]?.url || null;
}

/**
 * Extrait toutes les URLs d'images d'un produit (champ `media`).
 * Utilisé pour la galerie de la page détail.
 */
export function getProductImages(media: unknown): string[] {
  if (!media) return [];

  let items: ProductMediaItem[] = [];
  if (Array.isArray(media)) {
    items = media as ProductMediaItem[];
  } else if (typeof media === 'string') {
    try {
      const parsed = JSON.parse(media);
      if (Array.isArray(parsed)) items = parsed;
    } catch {
      return [];
    }
  }

  return items
    .filter((m) => m && m.url && (m.type === 'image' || !m.type))
    .map((m) => m.url);
}